/*
 * @Author: xiang.gao xiang.gao@travel-easy.com
 * @Date: 2023-11-17 17:08:46
 * @LastEditors: xiang.gao xiang.gao@travel-easy.com
 * @LastEditTime: 2023-11-28 10:12:59
 * @FilePath: /base-frontend/src/mixins/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useI18n } from "vue-i18n";

export default function () {
  const { t } = useI18n();
  /**
   * 表单验证错误消息弹框
   */
  const showValidateErrorMsg = () => {
    Swal.fire({
      text: t("common.submitErrors"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("common.okGotIt"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  };

  /**
   * 表单提交成功提示弹框
   */
  const showFormSubmitSuccessMsg = (callback?) => {
    Swal.fire({
      text: t("common.submitSuccess"),
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: t("common.okGotIt"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    }).then(() => {
      callback && callback();
    });
  };

  /**
   * 显示服务端错误消息弹框
   */
  const showServerErrorMsg = (res) => {
    if (res.sub_code.indexOf("FORM-VALIDATION") != -1) {
      //服务端数据验证错误
      const errorMsg = res.data;
      let htmlMsg = "";
      if (errorMsg) {
        for (const key in errorMsg) {
          htmlMsg += errorMsg[key] ? errorMsg[key][0] + "<br/>" : "";
        }
      }
      Swal.fire({
        title: res.sub_msg,
        icon: "error",
        html: htmlMsg,
      });
    } else {
      //服务端其他错误
      Swal.fire({
        title: res.msg,
        text: res.sub_msg,
        icon: "error",
      });
    }
  };

  return {
    showValidateErrorMsg,
    showFormSubmitSuccessMsg,
    showServerErrorMsg,
  };
}
